import {
  buildWhatsAppLegacyPayload,
  buildWhatsAppLegacyResponse,
  formatWhatsAppPhone,
  sanitizeWhatsAppText,
  sendCurrentWhatsAppMessage,
} from './sendWhatsAppCurrent'
import { createProducerQuotationTemplateParams, WHATSAPP_TEMPLATES } from './whatsappTemplates'

export default function sendWsQuote(producers, message) {
  const wsPosts = producers.map(async (producer) => {
    const recipient = formatWhatsAppPhone(producer.contact[0].phone)

    try {
      await sendCurrentWhatsAppMessage({
        to: recipient,
        template: WHATSAPP_TEMPLATES.PRODUCER_QUOTATION,
        params: createProducerQuotationTemplateParams({
          producerName: sanitizeWhatsAppText(producer.brand_name),
          itemsText: sanitizeWhatsAppText(message),
        }),
      })

      return buildWhatsAppLegacyResponse(buildWhatsAppLegacyPayload(recipient, true))
    } catch (error) {
      return buildWhatsAppLegacyResponse(
        buildWhatsAppLegacyPayload(
          recipient,
          false,
          error.message || 'No fue posible enviar la cotización por WhatsApp.',
        ),
      )
    }
  })

  return Promise.allSettled(wsPosts)
}
